// Code generated by protoc-gen-zeroapi. DO NOT EDIT.

import service from '@/lobby_common/utils/request'

// 竞猜投注
// Req : open_proto.client.v1.guess.GuessBetReq
// Resp: open_proto.client.v1.guess.GuessBetResp
export const guessBet = (data) => {
  return service({
    url: '/v1/guess/guessBet',
    method: 'post',
    data
  })
}
// 获取竞猜列表
// Req : open_proto.client.v1.guess.GetGuessListReq
// Resp: open_proto.client.v1.guess.GetGuessListResp
export const getGuessList = (data) => {
  return service({
    url: '/v1/guess/guessList',
    method: 'post',
    data
  })
}
// 预览竞猜投注
// Req : open_proto.client.v1.guess.GuessBetReq
// Resp: open_proto.client.v1.guess.PreviewGuessBetResp
export const previewGuessBet = (data) => {
  return service({
    url: '/v1/guess/previewGuessBet',
    method: 'post',
    data
  })
}
// 获取奖励下注总额
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.guess.GetGuessBetTotalResp
export const getGuessBetTotal = (data) => {
  return service({
    url: '/v1/guess/getGuessBetTotal',
    method: 'post',
    data
  })
}
// 获取破产配置
// Req : open_proto.common.Undefined
// Resp: open_proto.client.v1.guess.GetBankruptConfigResp
export const getBankruptConfig = (data) => {
  return service({
    url: '/v1/guess/getBankruptConfig',
    method: 'post',
    data
  })
}
// 选择破产引导类型
// Req : open_proto.client.v1.guess.ChooseBankruptGuideTypeReq
// Resp: open_proto.common.Undefined
export const chooseBankruptGuideType = (data) => {
  return service({
    url: '/v1/guess/chooseBankruptGuideType',
    method: 'post',
    data
  })
}
